<template>
  <section class="page-container">
    <h1>Endorsements Waiting Purchase</h1>
    <div class="filter-container">
      <div class="flex">
        <div class="filter-box">
          <span class="label">Search</span>
          <div class="search-box">
            <v-input
              v-model="search"
              placeholder="Policy No., Customer Name, Insurer, Referrer or Price"
              @keyEnter="filterData" />
          </div>
        </div>
        <div class="filter-box">
          <span class="label">Issue Date</span>
          <div class="search-box">
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
        </div>
      </div>

      <div class="filter-box">
        <span class="label">
          Product Type
          <span
            class="all"
            @click="handlerSelectAll('product_id')">Select All</span>
        </span>
        <v-checkbox-group
          v-model="product_id"
          :list="productTypeOptions"
          @change="filterData"></v-checkbox-group>
      </div>
      <div class="filter-box">
        <span class="label">
          Insurer
          <span
            class="all"
            @click="handlerSelectAll('company_id')">Select All</span>
        </span>
        <v-checkbox-group
          v-model="company_id"
          :list="insurerOptions"
          @change="filterData"></v-checkbox-group>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        @row-click="rowClick">
        <el-table-column
          prop="issue_dt"
          label="Issue Date & Time"></el-table-column>
        <el-table-column
          prop="id"
          label="Ticket ID"></el-table-column>
        <el-table-column
          prop="product_language"
          label="Product Type"></el-table-column>
        <el-table-column
          prop="company_language"
          label="Insurer"></el-table-column>
        <el-table-column
          prop="isrd_nm"
          label="Policyholder"></el-table-column>
        <el-table-column
          prop="contact_nm"
          label="Contact Name"></el-table-column>
        <el-table-column
          prop="contact_no"
          label="Phone No."></el-table-column>
        <el-table-column
          prop="period"
          label="Policy Period"></el-table-column> 
        <el-table-column
          prop="status_language"
          label="Status">
        </el-table-column>
        <el-table-column
          prop="tickets"
          label="Payable">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | formatMoney(2, true) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import { getPolicyModifyList } from '@/api/modify'
export default {
  name: 'Quotes',
  mixins: [MixinOptions, MixinFormat],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: []
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getPolicyModifyList()
      }
    }
  },
  methods: {
    rowClick(row) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: row.id
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productTypeOptions'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getPolicyModifyList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getPolicyModifyList()
    },
    network() {
      return {
        getPolicyModifyList: async () => {
          const { data } = await getPolicyModifyList({
            issue_start: this.date? this.date[0]: '',
            issue_end: this.date? this.date[1]: '',
            product_id: this.product_id,
            company_id: this.company_id,
            // stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
 .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>